import React from 'react';
import { ExtendedFlex, ScrollToTopOnMount } from '../../coreui';

const Container = ({
  children,
  ...props
}) => {
  return (
    <ExtendedFlex
      flexDirection="row"
      justify="center"
      my={50}
      mx="auto"
      maxWidth={1200}
      width="90%"
      {...props}
    >
      <ScrollToTopOnMount />
      {children}
    </ExtendedFlex>
  );
};

export default Container;
